import { createFormUrlApi } from '../../api/create-form-url';
import { ApiHost, PaymentFrameEventsV2, TokenizeCardV2Options } from '../../types';
import { paymentForm } from '../payment-form';

export const tokenizeCardV2 = async (apiHost: ApiHost, options: TokenizeCardV2Options) => {
    const url = await createFormUrlApi(apiHost, { ...options, method: 'tokenize', flow: 'card' });

    return paymentForm<PaymentFrameEventsV2>(apiHost, { url });
};
